<template>
  <v-card elevation="24" class="background-card">

    <v-row dense class="justify-begin ml-1 mt-n9">
      <v-col densecols="auto">
        <Headers
        :headersTitle="'Kalender/Belegung'"
        :headersIcon="'mdi-calendar'"
      />
      </v-col>
    </v-row>

    <v-card class="info-Card" elevation="12">
      <div class="info-content">
        <div class="info-text">
          Platz:
          <strong>{{ calendarCardSeat?.description || '—' }}</strong>
          <wbr>&nbsp;|
          Besitzer:
          <strong>
            {{ getOwnerName(calendarCardSeat?.owner) || '—' }}
          </strong>
        </div>
        <v-btn
          prepend-icon="mdi-cancel"
          variant="elevated"
          color="red"
          :disabled="!calendarCardSeat"
          @click="$emit('resetOccupancy', null)"
        >
          Auswahl aufheben
        </v-btn>
      </div>
    </v-card>

    <div class="calendar-area">
      <FullCalendar 
      :calendarSeat="calendarCardSeat"
      :calendarUsers="calendarCardUsers"
      :calendarSeatOwner="getOwnerName(calendarCardSeat?.owner)"
      @updateFavorite="$emit('updateFavorite')"
      @updateSeatStatus="$emit('updateSeatStatus')"/>
    </div>

  </v-card>
</template>

<script>

  import Headers from '../consumables/Headers.vue'
  import FullCalendar from '../consumables/FullCalendar.vue'
  import CalendarInfoLable from '../consumables/CalendarInfoLable.vue'

  export default {
    components: {
      Headers,
      FullCalendar,
      CalendarInfoLable
    },
    props: {
      calendarCardSeat: {type: Object, default: null},
      calendarCardUsers: {type: Object, default: null}
    },

    emits: ['updateFavorite', 'updateSeatStatus', 'resetOccupancy'],

    methods: {
      getOwnerName(seatOwner) {
        if (!seatOwner) {return '—'}
        
        const user = this.calendarCardUsers.users.find(item => item.id === seatOwner)
        return `${user.first_name} ${user.last_name}`;
      },
    }
  }

</script>

<style scoped>
.background-card {
  height: 100%;
  overflow: visible;
  padding: 1rem;
  background: rgba(var(--v-theme-surface), 0.72);
  backdrop-filter: blur(8px) saturate(120%);
  border: 1px solid rgba(var(--v-theme-surface).35);
  border-radius: 32px;
}
.info-Card {
  width: 100%;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 16px;
}
.info-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
}
.info-text {
  font-size: 1.1rem;
  word-break: break-word;
}
.v-btn {
  border-radius: 4px;
  margin-top: 2px;
  margin-bottom: 2px
}
.calendar-area {
  flex: 1 1 auto;
  min-height: 0;
  height: 44.1rem;
  width: 100%;
  overflow: auto;
  border-radius: 16px;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
}
</style>
